module.exports = __webpack_public_path__ + "assets/3adda5a66362b888f536e9c48ff36a64.mp3";